const OptGroup = () => null;
OptGroup.isSelectOptGroup = true;
OptGroup.displayName = 'PfSelectOptGroup';
export default OptGroup;
